/* eslint-disable */
//:// Changed it to this way, because the memory leak of building it with webpack was annoying
// Look into this
// https://stackoverflow.com/questions/29875869/react-jsx-dynamic-component-name

import Accessories from "../containers/accessories"
import AccessoryDetails from "../AtomicContainers/AccessoryDetails/AccessoryDetails"
import AccessoryList from "../AtomicContainers/AccessoryList/AccessoryList"
import AccordionText from "../AtomicContainers/AccordionText/AccordionText"
import AccordionTextList from "../AtomicContainers/AccordionTextList/AccordionTextList"
import ArticlePage from "../AtomicContainers/ArticlePage/ArticlePage"
import ArticlePreview from "../AtomicContainers/ArticlePreview/ArticlePreview"
import ArticleSelector from "../AtomicContainers/ArticleSelector/ArticleSelector"
import BackButton from "../AtomicComponents/BackButton/BackButton"
import BookServiceForm from "../AtomicContainers/BookServiceForm/BookServiceForm"
import BookTestDrive from "../AtomicContainers/BookTestDrive/BookTestDrive"
import BrowserWarning from "../AtomicContainers/BrowserWarning/BrowserWarning"
import ButtonGroup from "../AtomicComponents/ButtonGroup/ButtonGroup"
import Button from "../AtomicComponents/Button/Button"
import Card from "../AtomicComponents/Card/Card"
import CardYoutubePlayer from "../AtomicContainers/CardYoutubePlayer/CardYoutubePlayer"
import CardYoutubePlayerList from "../AtomicContainers/CardYoutubePlayerList/CardYoutubePlayerList"
import CompetitionForm from "../AtomicContainers/CompetitionForm/CompetitionForm"
import Section from "../AtomicComponents/Section/Section"
import ColumnGroup from "../AtomicComponents/ColumnGroup/ColumnGroup"
import CompareTool from "../containers/compare-tool"
import CompareVehicleSelector from "../containers/compare-vehicle-selector"
import Configurator from "../containers/build"
import ContentCard from "../AtomicContainers/ContentCard/ContentCard"
import ContentCardList from "../AtomicContainers/ContentCardList/ContentCardList"
import CorporateSelect from "../AtomicContainers/CorporateSelect/CorporateSelect"
import CountdownTimer from "../blocks/countdown-timer"
import DealerMapPage from "../blocks/dealer-map-page"
import DynamicTextVideoFrameBlock from "../blocks/dynamic-text-video-frame"
import FeaturedCategoriesTab from "../AtomicContainers/FeaturedCategoriesTab/FeaturedCategoriesTab"
import FeatureFocusBlock from "../AtomicContainers/FeatureFocusBlock/FeatureFocusBlock"
import FiftyFiftyBlock from "../AtomicContainers/FiftyFiftyBlock/FiftyFiftyBlock"
import FilteredOffers from "../AtomicContainers/Offers/Offers"
import FlexContent from "../blocks/global-nav-item-grid"
import FlexIconLink from "../components/nameplate-link"
import Footer from "../AtomicContainers/Footer/Footer"
import FullWidthImageSection from "AtomicContainers/FullWidthImageSection/FullWidthImageSection"
import FullWidthMultiVideoBlock from "../blocks/full-width-multi-video"
import Gallery from "../containers/gallery"
import GalleryFullWidth from "../containers/gallery-full-width"
import GalleryItem from "../containers/gallery-item"
import GetInTouch from "AtomicContainers/GetInTouch/GetInTouch"
import GlobalNav from "../containers/global-nav"
import GlobalNavDropdownBlock from "../blocks/global-nav-dropdown"
import GlobalNavItemGridBlock from "../blocks/global-nav-item-grid"
import GlobalNavLink from "../components/global-nav-link"
import GradePicker from "../AtomicContainers/GradePicker/GradePicker"
import GyroscopeBlock from "../blocks/gyroscope"
import Heading from "../AtomicContainers/Heading/Heading"
import HeadingSectionBlock from "../blocks/heading-section"
import Hero from "../AtomicContainers/Hero/Hero"
import HeroVideoWithTimedFrames from "../blocks/hero-video-with-timed-frames"
import Hyperlink from "../AtomicComponents/Typography/A"
import IconToutBlock from "../containers/icon-tout-block"
import IdWrapper from "../AtomicComponents/IdWrapper/IdWrapper"
import Image from "../AtomicContainers/Image/Image"
import Image360 from "../AtomicContainers/Image360/Image360"
import ImagesGallery from "AtomicContainers/Gallery/Gallery"
import ImagesRotator from "../AtomicContainers/ImagesRotator/ImagesRotator"
import ImageToutBlock from "../containers/image-tout-block"
import InteractiveSlideshowBlock from "../blocks/text-media-slider"
import InteriorPicker from "../AtomicContainers/InteriorPicker/InteriorPicker"
import MapSearchBlock from "../blocks/map-search"
import MapSelectStateBlock from "../blocks/map-select-state/index.js"
import ColorPicker from "AtomicContainers/ColorPicker/ColorPicker"
import MyMazda from "../blocks/mymazda"
import MyMazdaConfirmChangeEmailBlock from "../blocks/mymazda/confirm-change-email"
import MyMazdaCreateAccount from "../blocks/mymazda/create-account"
import MyMazdaDashboard from "../AtomicContainers/MyMazdaDashboard/MyMazdaDashboard"
import MyMazdaDashboardItem from "../AtomicContainers/MyMazdaDashboard/MyMazdaDashboardItem"
import MyMazdaDealerBlock from "../blocks/mymazda/dealer-block"
import MyMazdaDynamicResourceBlock from "../blocks/mymazda/dynamic-resource"
import MyMazdaDynamicResourceItem from "../blocks/mymazda/dynamic-resource/item"
import MyMazdaFullSpecBlock from "../blocks/mymazda/vehicle-specs"
import MyMazdaLogin from "../AtomicContainers/MyMazdaLogin/MyMazdaLogin"
import MyMazdaLoginBlock from "../AtomicContainers/MyMazdaLoginContainer/MyMazdaLoginContainer"
import MyMazdaManageAccountBlock from "../blocks/mymazda/manage-account"
import MyMazdaManageVehiclesBlock from "../blocks/mymazda/manage-vehicles"
import MyMazdaNotifications from "../blocks/mymazda/notifications"
import MyMazdaAccountPassword from "../blocks/mymazda/account-password"
import MyMazdaPolicies from "../blocks/mymazda/policies"
import MyMazdaPolicyDetail from "../blocks/mymazda/policies/detail"
import MyMazdaPolicyItem from "../blocks/mymazda/policies/item"
import MyMazdaPolicySummary from "../blocks/mymazda/policies/summary"
import MyMazdaRecallNotification from "../blocks/mymazda/recall-notification"
import MyMazdaRegistration from "../blocks/mymazda/registration"
import MyMazdaResetPassword from "../blocks/mymazda/reset-password"
import MyMazdaServiceHistoryExport from "../blocks/mymazda/service/export"
import MyMazdaServiceRequestFormBlock from "../blocks/mymazda/service/form"
import MyMazdaServiceSummaryBlock from "../blocks/mymazda/service/summary"
import MyMazdaSpecificationBlock from "../containers/mymazda-specifications-block"
import MyMazdaSummary from "../containers/mymazda-summary"
import MyMazdaUnauthRedirectBlock from "../blocks/mymazda/redirect"
import MyMazdaVehicleResourceList from "../blocks/mymazda/vehicle-resource-list"
import MyMazdaVehicleServiceCarouselBlock from "../blocks/mymazda/service/carousel"
import MyMazdaServiceHistory from "../AtomicContainers/MyMazdaServiceHistory/MyMazdaServiceHistory"
import MyMazdaVehicleSummary from "../AtomicContainers/MyMazdaVehicleSummary/MyMazdaVehicleSummary"
import MyNewMazda from "../AtomicContainers/MyNewMazda/MyNewMazda"
import NameplateLink from "../components/nameplate-link"
import NavDropdown from "../blocks/global-nav-dropdown"
import Offers from "../containers/offers"
import OfferFilterItem from "../AtomicContainers/OfferTile/OfferTile"
import OfferItem from "../containers/offers/offer-tile"
import OutletDetail from "../blocks/outlet-store-detail"
import OutletStoreContainer from "../containers/outlet-store"
import OutletStoreEnquiryForm from "../AtomicContainers/OutletStoreEnquiryForm/OutletStoreEnquiryForm"
import OutletStoreSpecificationsBlock from "../containers/outlet-store-specifications-block"
import Overlay from "../containers/overlay"
import PDFTemplate from "../AtomicContainers/PDFTemplate/PDFTemplate"
import PersonalisationBlockContainer from "../AtomicContainers/PersonalisationBlockContainer/PersonalisationBlockContainer"
import PersonalisationBlockItem from "../AtomicComponents/PersonalisationBlockItem/PersonalisationBlockItem"
import PostcodePopup from "../containers/postcode-popup"
import Price from "../AtomicContainers/Price/Price"
import RecallDocument from "../AtomicContainers/RecallDocument/RecallDocument"
import Recall from "../AtomicContainers/Recall/Recall"
import RegisterInterestForm from "../AtomicContainers/RegisterInterestForm/RegisterInterestForm"
import SaveForm from "../AtomicContainers/SaveForm/SaveForm"
import SaveShareCopy from "../AtomicContainers/SaveShareCopy/SaveShareCopy"
import ScrapedPage from "../containers/scraped-page"
import ServiceCalculatorOwner from "../containers/service-calculator-owner"
import ServiceCalculatorProspect from "../containers/service-calculator-prospect"
import ServiceDetailsFull from "../blocks/service-details-full"
import ShareForm from "../AtomicContainers/ShareForm/ShareForm"
import SingleDealerMapBlock from "../blocks/single-dealer-map"
import SiteSearchBlock from "../blocks/site-search"
import SixtyFourtyBlock from "../AtomicContainers/SixtyFourtyBlock/SixtyFourtyBlock"
import SocialIcons from "../AtomicComponents/SocialIcons/SocialIcons"
import SpecificationsBlock from "../AtomicContainers/SpecificationsBlock/SpecificationsBlock"
import Spotlight from "../AtomicComponents/Spotlight/Spotlight"
import StickyNav from "../AtomicContainers/StickyNav/StickyNav"
import StickySection from "../AtomicComponents/StickySection/StickySection"
import Testimonial from "../AtomicComponents/Testimonial/Testimonial"
import TimeClockVideoFrameBlock from "../blocks/time-clock-video-frame"
import ToutBlock from "../blocks/tout-block"
import TriggeredOverlay from "../containers/triggered-overlay"
import VehicleNotFoundPage from "../AtomicContainers/VehicleNotFoundPage/VehicleNotFoundPage"
import VideoPlayer from "../AtomicContainers/VideoPlayer/VideoPlayer"
import VideoSlideshow from "../components/video-slideshow"
import WysiwygContent from "../AtomicComponents/Content/Content"

const moduleImporter = (name) => {
  const components = {
    Accessories:Accessories,
    AccessoryDetails:AccessoryDetails,
    AccessoryList:AccessoryList,
    AccessoryPackDetails:AccessoryDetails,
    Accordion:AccordionText,
    AccordionGroup:AccordionTextList,
    ArticlePage:ArticlePage,
    ArticlePreview:ArticlePreview,
    ArticleSelector:ArticleSelector,
    BackButton:BackButton,
    BookServiceForm:BookServiceForm,
    BookTestdriveForm:BookTestDrive,
    BrowserWarning:BrowserWarning,
    Button:Button,
    ButtonGroup:ButtonGroup,
    Card:Card,
    CardYoutubePlayer:CardYoutubePlayer,
    CardYoutubePlayerList:CardYoutubePlayerList,
    Column:Section,
    ColumnGroup:ColumnGroup,
    CompareTool:CompareTool,
    CompareVehicleSelector:CompareVehicleSelector,
    CompetitionForm:CompetitionForm,
    Configurator:Configurator,
    ContactUsForm:GetInTouch,
    ContentCard:ContentCard,
    ContentCardList:ContentCardList,
    CorporateSelectForm:CorporateSelect,
    CountdownTimer:CountdownTimer,
    DealerMapPage:DealerMapPage,
    DynamicTextVideoFrameBlock:DynamicTextVideoFrameBlock,
    FeaturedCategoriesTab:FeaturedCategoriesTab,
    FeatureFocusBlock:FeatureFocusBlock,
    FeatureYouTube:CardYoutubePlayer,
    FiftyFiftyBlock:FiftyFiftyBlock,
    FlexContent:FlexContent,
    FlexIconLink:FlexIconLink,
    Footer:Footer,
    FullWidthImageSection:FullWidthImageSection,
    FullWidthMultiVideoBlock:FullWidthMultiVideoBlock,
    Gallery:Gallery,
    GalleryFullWidth:GalleryFullWidth,
    GalleryItem:GalleryItem,
    GlobalNav:GlobalNav,
    NavDropdown:GlobalNavDropdownBlock,
    GlobalNavItemGridBlock:GlobalNavItemGridBlock,
    NavLink:GlobalNavLink,
    GradePicker:GradePicker,
    GyroscopeBlock:GyroscopeBlock,
    Heading:Heading,
    HeadingSectionBlock:HeadingSectionBlock,
    Hero:Hero,
    HeroVideoWithTimedFrames:HeroVideoWithTimedFrames,
    Hyperlink:Hyperlink,
    IconToutBlock:IconToutBlock,
    IdWrapper:IdWrapper,
    Image:Image,
    Image360:Image360,
    ImagesGallery:ImagesGallery,
    ImagesRotatorBlock:ImagesRotator,
    ImageToutBlock:ImageToutBlock,
    InPageNavigation:StickyNav,
    InteractiveSlideshowBlock:InteractiveSlideshowBlock,
    InteriorPicker:InteriorPicker,
    MapSearchBlock:MapSearchBlock,
    MapSelectStateBlock:MapSelectStateBlock,
    MiniConfigurator:ColorPicker,
    MyMazda:MyMazda,
    MyMazdaAccountPassword:MyMazdaAccountPassword,
    MyMazdaConfirmChangeEmailBlock:MyMazdaConfirmChangeEmailBlock,
    MyMazdaCreateAccount:MyMazdaCreateAccount,
    MyMazdaDashboard:MyMazdaDashboard,
    MyMazdaDashboardItem:MyMazdaDashboardItem,
    MyMazdaDealerBlock:MyMazdaDealerBlock,
    MyMazdaDynamicResourceBlock:MyMazdaDynamicResourceBlock,
    MyMazdaDynamicResourceItem:MyMazdaDynamicResourceItem,
    MyMazdaFullSpecBlock:MyMazdaFullSpecBlock,
    MyMazdaLogin:MyMazdaLogin,
    MyMazdaLoginBlock:MyMazdaLoginBlock,
    MyMazdaManageAccountBlock:MyMazdaManageAccountBlock,
    MyMazdaManageVehiclesBlock:MyMazdaManageVehiclesBlock,
    MyMazdaNotifications:MyMazdaNotifications,
    MyMazdaPolicies:MyMazdaPolicies,
    MyMazdaPolicyDetail:MyMazdaPolicyDetail,
    MyMazdaPolicyItem:MyMazdaPolicyItem,
    MyMazdaPolicySummary:MyMazdaPolicySummary,
    MyMazdaRecallNotification:MyMazdaRecallNotification,
    MyMazdaRegistration:MyMazdaRegistration,
    MyMazdaResetPassword:MyMazdaResetPassword,
    MyMazdaServiceHistoryExport:MyMazdaServiceHistoryExport,
    MyMazdaServiceRequestFormBlock:MyMazdaServiceRequestFormBlock,
    MyMazdaServiceSummaryBlock:MyMazdaServiceSummaryBlock,
    MyMazdaSpecificationBlock:MyMazdaSpecificationBlock,
    MyMazdaSummary:MyMazdaSummary,
    MyMazdaUnauthRedirectBlock:MyMazdaUnauthRedirectBlock,
    MyMazdaVehicleResourceList:MyMazdaVehicleResourceList,
    MyMazdaVehicleServiceCarouselBlock:MyMazdaVehicleServiceCarouselBlock,
    MyMazdaVehicleServiceHistoryBlock:MyMazdaServiceHistory,
    MyMazdaVehicleSummaryBlock:MyMazdaVehicleSummary,
    MyNewMazda:MyNewMazda,
    NameplateLink:NameplateLink,
    FilteredOffers:FilteredOffers,
    Offers:Offers,
    OfferFilterItem:OfferFilterItem,
    OfferItem:OfferItem,
    OutletDetail:OutletDetail,
    OutletStore:OutletStoreContainer,
    OutletStoreEnquiryForm:OutletStoreEnquiryForm,
    OutletStoreSpecificationsBlock:OutletStoreSpecificationsBlock,
    Overlay:Overlay,
    PDFTemplate:PDFTemplate,
    PersonalisationBlockContainer:PersonalisationBlockContainer,
    PersonalisationBlockItem:PersonalisationBlockItem,
    PostcodePopup:PostcodePopup,
    Price:Price,
    RecallDocument:RecallDocument,
    RecallsBlock:Recall,
    RegisterInterestForm:RegisterInterestForm,
    SaveForm:SaveForm,
    SaveShareCopy:SaveShareCopy,
    ScrapedPage:ScrapedPage,
    ServiceCalculatorOwner:ServiceCalculatorOwner,
    ServiceCalculatorProspect:ServiceCalculatorProspect,
    ServiceDetailsFull:ServiceDetailsFull,
    ShareForm:ShareForm,
    SingleDealerMapBlock:SingleDealerMapBlock,
    SiteSearchBlock:SiteSearchBlock,
    SixtyFourtyBlock:SixtyFourtyBlock,
    SocialIcons:SocialIcons,
    SpecificationsBlock:SpecificationsBlock,
    Spotlight:Spotlight,
    StickySection:StickySection,
    Testimonial:Testimonial,
    TimeClockVideoFrameBlock:TimeClockVideoFrameBlock,
    ToutBlock:ToutBlock,
    TriggeredOverlay:TriggeredOverlay,
    VehicleNotFoundPage:VehicleNotFoundPage,
    VideoPlayer:VideoPlayer,
    VideoSlideshow:VideoSlideshow,
    WysiwygContent:WysiwygContent
  };
  return components[`${name}`]
}

export default moduleImporter



// WEBPACK FOOTER //
// ./src/AtomicUtils/moduleImporter.js